import { SettingsContent, SettingsContentTypes } from './settings';
import { DestructuredURL, Link } from './shared';
import { RequestContext } from '../../types/request-context';

export enum WatchHistoryContentType {
    WatchHistoryCMP = 'atv.wps#WatchHistoryCMP',
    WatchHistoryEmpty = 'atv.wps#WatchHistoryEmpty',
    WatchHistoryItemsOutput = 'atv.wps#WatchHistoryItemsOutput'
}

export interface WatchHistoryContent { __type: WatchHistoryContentType}

export interface WatchHistoryOutput extends SettingsContent {
    __type: SettingsContentTypes.WatchHistoryOutput;
    content: WatchHistoryContent;
}

export interface WatchHistoryCMP extends WatchHistoryContent {
    __type: WatchHistoryContentType.WatchHistoryCMP;
    message: string;
    cmpWatchHistoryButton: Link;
}

export interface WatchHistoryEmpty extends WatchHistoryContent {
    __type: WatchHistoryContentType.WatchHistoryEmpty;
    message: string;
}

export interface WatchHistoryItemsOutput extends WatchHistoryContent {
    __type: WatchHistoryContentType.WatchHistoryItemsOutput;
    titles: WatchedTitle[];
    intro?: string;
    seeMoreHref?: Link;
    nextPageApiUrl?: string;
}

export interface WatchedTitle {
    title: Link;
    id: string;
    imageSrc: string;
    stateChangeEndpoint?: DestructuredURL;
}

export interface WatchHistoryPagination {
    totalPages: number;
    currentPage: number;
}

// WatchHistoryStateChange
export interface WatchHistoryStateChangeInput {
    context: RequestContext;
    id: string;
    token: string;
    tag: WatchHistoryActionTag;
}

export enum WatchHistoryActionTag {
    REMOVE = "Remove"
}
export interface WatchHistoryStateChangeOutput {
    isSuccess: boolean;
    message: string;
    followUpAction?: Link;
}
